import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '@/view/LandingPage.vue';
import Home from '@/view/HomePage.vue';
import UserGuide from '@/view/UserGuide.vue';
import TemplateGallery from '@/view/TemplateGallery.vue';
import WechatCallback from '@/view/WechatCallback.vue';
import CoverPage from '@/view/CoverPage.vue';
import TableOfContentsPage from '@/view/TableOfContentsPage.vue';
import { SourceTracker } from '@/utils/sourceTracker';

const routes = [
  { 
    path: '/', 
    name: 'Landing', 
    component: LandingPage,
    meta: { title: '芝麻开花智能写作平台' }
  },
  { 
    path: '/writing', 
    name: 'Writing', 
    component: Home,
    meta: { title: '芝麻开花智能写作平台 - AI写作' }
  },
  { 
    path: '/user-guide', 
    name: 'UserGuide', 
    component: UserGuide,
    meta: { title: '芝麻开花智能写作平台 - 用前必看' }
  },
  { 
    path: '/template-gallery', 
    name: 'TemplateGallery', 
    component: TemplateGallery,
    meta: { title: '芝麻开花智能写作平台 - 范文展示' }
  },
  { 
    path: '/wechat-callback', 
    name: 'WechatCallback', 
    component: WechatCallback,
    meta: { title: '微信支付处理中...' }
  },
  {
    path: '/cover',
    name: 'CoverPage',
    component: CoverPage,
    meta: { title: '论文封面' }
  },
  {
    path: '/toc',
    name: 'TableOfContentsPage',
    component: TableOfContentsPage,
    meta: { title: '论文目录' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 全局路由守卫，动态设置页面title和记录来源URL
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title as string;
  } else {
    document.title = '芝麻开花智能写作平台';
  }
  
  // 每次路由跳转时检查并清理过期缓存
  SourceTracker.cleanupExpiredCache();
  
  // 如果是首次访问（from.name为undefined），记录来源URL
  if (!from.name) {
    SourceTracker.recordSourceUrl();
    
    // 输出调试信息，帮助排查问题
    console.log('首次访问检测到，来源信息:');
    const sourceInfo = SourceTracker.getSourceInfo();
    const cacheStatus = SourceTracker.getCacheStatus();
    
    console.log('- 来源URL:', sourceInfo.url);
    console.log('- 来源类型:', sourceInfo.type);
    if (sourceInfo.keyword) {
      console.log('- 搜索关键词:', sourceInfo.keyword);
    }
    console.log('- 进入时间:', sourceInfo.entryTime);
    console.log('- 会话ID:', sourceInfo.sessionId);
    console.log('- 缓存状态:', cacheStatus.isValid ? '有效' : '无效');
    console.log('- 剩余时间:', Math.round(cacheStatus.remainingTime / 1000 / 60), '分钟');
  }
  
  next();
});

export default router;